import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Container from 'common/Container';

const Hero = ({ themeMode = 'light' }) => {
  const theme = useTheme();

  return (
    <Box
      minHeight={{ xs: 'auto', md: 'calc(100vh - 64px)' }}
      height="auto"
      position="relative"
      display="flex"
      alignItems="center"
      justifyContent="center"
      sx={{
        backgroundImage:
          'linear-gradient(135deg, rgba(0,40,80,0.92) 0%, rgba(0,90,140,0.88) 50%, rgba(20,20,40,0.9) 100%)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        '&:after': {
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          content: '" "',
          zIndex: 1,
          backgroundColor: theme.palette.primary.dark,
          opacity: 0.55,
        },
      }}
    >
      <Box position="relative" zIndex={2} width="100%">
        <Container>
          <Box textAlign="center" color="common.white">
            <Box
              sx={{
                backgroundImage: 'url(/images/logos/logo_white.PNG)',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                backgroundSize: 'contain',
                height: { xs: 80, md: 120 },
                maxWidth: 320,
                mx: 'auto',
                mb: 3,
              }}
            />
            <Typography
              sx={{ textTransform: 'uppercase', fontWeight: 600, letterSpacing: 1 }}
              variant="overline"
              display="block"
              gutterBottom
            >
              Propuesta de Comercialización 360
            </Typography>
            <Typography variant="h2" fontWeight={900} gutterBottom align="center">
              Óptica Berlud × TNO Network
            </Typography>
            <Typography variant="h6" component="p" align="center" sx={{ fontWeight: 400, opacity: 0.95 }}>
              Tradición, calidad y servicio ante tus ojos
            </Typography>
            <Typography variant="body1" align="center" sx={{ mt: 2, opacity: 0.9, maxWidth: 620, mx: 'auto' }}>
              Noticiero, rotativa, TNO Digest, inserts y micros en estudio (Plata y Oro). Planes Bronce ($290), Plata ($480) y Oro ($720) mensuales.
            </Typography>
          </Box>
        </Container>
      </Box>
    </Box>
  );
};

export default Hero;
